import { ContentStream, ViewMode } from '@lumapps/content-streams/types';
import type { TranslateObject } from '@lumapps/translations';

export enum Status {
    loading = 'loading',
    loaded = 'loaded',
}

export interface ValueObject {
    uid: string;
    name: TranslateObject;
}

// eslint-disable-next-line no-use-before-define
export type Fields = keyof Form['fields'];

export interface Form {
    uid: string;
    isConfirmDeleteOpen?: boolean;
    isOpen?: boolean;
    status?: Status;
    wasTouched?: boolean;
    hasError?: boolean;
    fields: {
        label: {
            value: Record<string, string>;
            errorMessage?: string;
            wasTouched?: boolean;
        };
        feeds: {
            value: string[];
        };
        viewMode: {
            value: ViewMode;
            choices?: string[];
            isOpen?: boolean;
        };
        featuredOnly: { value: boolean };
        highlightedOnly: { value: boolean };
        favoriteSitesOnly: { value: boolean };
        defaultInstanceRelatives: { value: boolean };
        limit: {
            value: number;
            errorMessage?: string;
            wasTouched?: boolean;
        };
        instances: {
            value: string[];
            wasTouched?: boolean;
            errorMessage?: string;
        };
        contentTypes: {
            value: string[];
        };
        categories: {
            value: string[];
        };
        metadata: {
            /** Selected Metadata by Family ID. */
            value: Record<string, string[]>;
        };
    };
}

export interface ContentStreamAdminState {
    /**
     * Content stream by UID.
     */
    entities: Record<string, ContentStream>;
    /**
     * Content stream forms by UID.
     */
    forms: Record<string, Form>;
    /**
     * Content stream UID list.
     */
    streamList: string[];
    /**
     * Content stream admin status.
     */
    status?: Status;
}
